import { render, staticRenderFns } from "./SemiButton.vue?vue&type=template&id=3824364a&scoped=true&"
import script from "./SemiButton.vue?vue&type=script&lang=js&"
export * from "./SemiButton.vue?vue&type=script&lang=js&"
import style0 from "./SemiButton.vue?vue&type=style&index=0&id=3824364a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3824364a",
  null
  
)

export default component.exports